import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface identifierProps {
	identifier?: string;
}

const initialState: identifierProps = {
	identifier: "",
};

const identifierSlice = createSlice({
	name: "identifier",
	initialState,
	reducers: {
		updateIdentifier: (state, action: PayloadAction<identifierProps>) => {
			return {
				...state,
				identifier: action?.payload?.identifier,
			};
		},
		clearIdentifier: state => {
			state.identifier = "";
		},
	},
});

export default identifierSlice.reducer;

export const { updateIdentifier, clearIdentifier } = identifierSlice.actions;
